import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-date-picker-custom',
  templateUrl: './date-picker-custom.component.html',
  styleUrls: ['./date-picker-custom.component.scss']
})
export class DatePickerCustomComponent {
  @Output() formValid = new EventEmitter<boolean>();
  @ViewChild('childForm') childForm!: NgForm;

  @Output() dateChange = new EventEmitter<Date>();
  today = moment();
  yearRange: number[] = [];
  daysInMonth: number[] = [];
  selectedDay: number | null = null;
  selectedMonth: number;
  selectedYear: number;
  minDate: string;
  maxDate: string;
  minYear: number;
  maxYear: number;
  monthsRange = Array.from({ length: 12 }, (_, i) => i + 1);

  @Input() initialDate: string | null = null;


  constructor() {
    this.updateYearRange();
    this.updateDaysInMonth();
  }

  ngOnInit() {
    if (this.initialDate) {
      const [year, month, day] = this.initialDate.split('-').map(Number);
      this.selectedYear = year;
      this.selectedMonth = month;
      this.selectedDay = day;
      this.formValid.emit(true);
    }

    this.maxDate = this.today.subtract(18, 'years').format('MM/DD/YYYY');
    this.minDate = this.today.subtract(100 - 18, 'years').format('MM/DD/YYYY');
    this.maxYear = parseInt(this.maxDate.split('/')[2], 10);
    this.minYear = parseInt(this.minDate.split('/')[2], 10);
    this.yearRange = this.generateYearRange(this.minYear, this.maxYear);
  }

  generateYearRange(start: number, end: number): number[] {
    return Array.from({ length: end - start + 1 }, (_, i) => end - i);
  }

  ngOnChanges() {
    this.updateDaysInMonth();
  }

  updateYearRange() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 100; i <= currentYear + 100; i++) {
      this.yearRange.push(i);
    }
  }

  updateDaysInMonth() {
    const MONTH = this.selectedMonth ? this.selectedMonth : 1;
    const YEAR = this.selectedYear ? this.selectedYear : new Date().getFullYear();

    const DATE = new Date(YEAR, MONTH, 0);
    const DAYS = DATE.getDate();

    this.daysInMonth = Array.from({ length: DAYS }, (_, i) => i + 1);

    if (this.selectedDay && this.selectedDay > DAYS) {
      this.selectedDay = DAYS;
    }

    this.emitDateChange();
  }

  emitDateChange() {
    if (this.selectedDay && this.selectedMonth && this.selectedYear) {
      const formattedDate = new Date(this.selectedYear, this.selectedMonth - 1, this.selectedDay);
      this.dateChange.emit(formattedDate);
    }
  }

  onFormChange() {
    setTimeout(() => {
      this.formValid.emit(this.childForm.valid);
    });
  }

}
